// extracted by mini-css-extract-plugin
export default {"layout":"AdminPanel_layout__OPtJI","content":"AdminPanel_content__95UMk"};